import { useState } from 'react';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (formData.message.length > 500) {
      setSubmitMessage('訊息內容不能超過500字');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value.toString());
      });

      const response = await fetch('https://readdy.ai/api/form/d4bvg24rg8gnguu95jr8', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitMessage('訊息已成功送出！我們會盡快回覆您。');
        setFormData({
          name: '',
          phone: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        setSubmitMessage('送出失敗，請稍後再試。');
      }
    } catch (error) {
      setSubmitMessage('送出失敗，請檢查網路連接。');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12">
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            聯絡我們
          </h3>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed px-4">
            有任何問題嗎？歡迎隨時與我們聯繫
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
          {/* 聯絡資訊 */}
          <div>
            <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">聯絡資訊</h4>
            <div className="space-y-4 sm:space-y-6">
              <div className="flex items-start space-x-3 sm:space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-emerald-100 rounded-xl flex-shrink-0">
                  <i className="ri-map-pin-line text-emerald-600 text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">營隊地址</h5>
                  <p className="text-sm sm:text-base text-gray-600">台中市北屯區北屯路388號2樓</p>
                </div>
              </div>

              <div className="flex items-start space-x-3 sm:space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-emerald-100 rounded-xl flex-shrink-0">
                  <i className="ri-phone-line text-emerald-600 text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">聯絡電話</h5>
                  <p className="text-sm sm:text-base text-gray-600">(04) 2243-6255</p>
                </div>
              </div>

              <div className="flex items-start space-x-3 sm:space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-emerald-100 rounded-xl flex-shrink-0">
                  <i className="ri-mail-line text-emerald-600 text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">電子信箱</h5>
                  <p className="text-sm sm:text-base text-gray-600 break-all">richqazstrong@yahoo.com.tw</p>
                </div>
              </div>

              <div className="flex items-start space-x-3 sm:space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-emerald-100 rounded-xl flex-shrink-0">
                  <i className="ri-time-line text-emerald-600 text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">營業時間</h5>
                  <div className="text-sm sm:text-base text-gray-600 space-y-1">
                    <p>週一至週五：09:00 - 21:00</p>
                    <p>週六：09:00 - 21:00</p>
                    <p>週日：休息</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-6 sm:mt-8 bg-gradient-to-r from-emerald-50 to-blue-50 rounded-2xl p-4 sm:p-6">
              <h5 className="font-bold text-gray-900 mb-2 sm:mb-3 flex items-center text-sm sm:text-base">
                <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center mr-2 text-emerald-600">
                  <i className="ri-customer-service-line"></i>
                </div>
                需要協助？
              </h5>
              <p className="text-gray-700 text-xs sm:text-sm leading-relaxed mb-3 sm:mb-4">
                歡迎點擊右下角的AI助理，我們將即時為您解答課程相關問題，並協助您完成報名流程！
              </p>
              <button
                onClick={() => {
                  const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
                  if (widget) {
                    widget.click();
                  }
                }}
                className="bg-emerald-600 text-white px-5 sm:px-6 py-2 sm:py-3 rounded-full font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap text-sm sm:text-base"
              >
                <i className="ri-customer-service-line mr-2"></i>
                立即諮詢
              </button>
            </div>
          </div>

          {/* LINE 聯絡方式 */}
          <div>
            <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6 flex items-center">
              <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center mr-2 sm:mr-3 text-green-500">
                <i className="ri-line-fill"></i>
              </div>
              LINE 即時聯絡
            </h4>
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 sm:p-8">
              <div className="text-center">
                <div className="inline-block bg-white rounded-2xl p-3 sm:p-4 shadow-lg mb-4 sm:mb-6">
                  <img
                    src="https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/a7f5034a184c0574bf4415ff688caa0e.jpeg"
                    alt="LINE QR Code"
                    className="w-40 h-40 sm:w-48 sm:h-48 mx-auto rounded-xl"
                  />
                </div>
                
                <h5 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">
                  掃描 QR Code 加入 LINE
                </h5>
                
                <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm mb-4 sm:mb-6">
                  <div className="space-y-3 sm:space-y-4 text-left">
                    <div className="flex items-start space-x-2 sm:space-x-3">
                      <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-1">
                        <span className="text-green-600 font-bold text-xs sm:text-sm">1</span>
                      </div>
                      <div>
                        <h6 className="font-semibold text-gray-800 mb-1 text-sm sm:text-base">開啟 LINE App</h6>
                        <p className="text-xs sm:text-sm text-gray-600">在手機上開啟 LINE 應用程式</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start space-x-2 sm:space-x-3">
                      <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-1">
                        <span className="text-green-600 font-bold text-xs sm:text-sm">2</span>
                      </div>
                      <div>
                        <h6 className="font-semibold text-gray-800 mb-1 text-sm sm:text-base">掃描 QR Code</h6>
                        <p className="text-xs sm:text-sm text-gray-600">點擊「加入好友」→「QR Code」掃描上方圖片</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start space-x-2 sm:space-x-3">
                      <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-1">
                        <span className="text-green-600 font-bold text-xs sm:text-sm">3</span>
                      </div>
                      <div>
                        <h6 className="font-semibold text-gray-800 mb-1 text-sm sm:text-base">開始聊天</h6>
                        <p className="text-xs sm:text-sm text-gray-600">加入好友後即可開始詢問課程問題</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-emerald-100 rounded-xl p-3 sm:p-4 mb-4 sm:mb-6">
                  <h6 className="font-bold text-emerald-800 mb-2 flex items-center justify-center text-sm sm:text-base">
                    <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mr-2">
                      <i className="ri-chat-smile-3-line"></i>
                    </div>
                    LINE 聯絡優點
                  </h6>
                  <div className="text-xs sm:text-sm text-emerald-700 space-y-2">
                    <div className="flex items-center justify-center flex-wrap gap-2 sm:gap-4">
                      <span>✓ 即時回覆</span>
                      <span>✓ 方便溝通</span>
                      <span>✓ 圖片傳送</span>
                    </div>
                    <div className="flex items-center justify-center flex-wrap gap-2 sm:gap-4">
                      <span>✓ 語音訊息</span>
                      <span>✓ 隨時諮詢</span>
                      <span>✓ 快速報名</span>
                    </div>
                  </div>
                </div>

                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 sm:p-4 rounded-r-xl">
                  <div className="flex items-start">
                    <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center mr-2 sm:mr-3 flex-shrink-0">
                      <i className="ri-information-line text-yellow-600"></i>
                    </div>
                    <div className="text-left">
                      <h6 className="font-semibold text-yellow-800 mb-1 text-sm sm:text-base">貼心提醒</h6>
                      <p className="text-xs sm:text-sm text-yellow-700 leading-relaxed">
                        透過 LINE 聯絡我們，可以更快速地為您解答營隊相關問題、協助報名流程，以及提供最新的優惠資訊！歡迎家長們隨時聯繫。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 地圖區域 */}
        <div className="mt-12 sm:mt-16">
          <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6 text-center">營隊位置</h4>
          <div className="bg-gray-100 rounded-2xl overflow-hidden shadow-lg h-64 sm:h-80 md:h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3640.7373026!2d120.6812345!3d24.1678901!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34693d5b1234abcd%3A0x5678efgh9012ijkl!2z5Y-w5Lit5biC5YyX5bGv5Y2A5YyX5bGv6LevMzg45be3MuaogQ!5e0!3m2!1szh-TW!2stw!4v1640995200000!5m2!1szh-TW!2stw&q=台中市北屯區北屯路388號2樓"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="CMAP營隊位置地圖 - 台中市北屯區北屯路388號2樓"
            ></iframe>
          </div>

          <div className="mt-4 sm:mt-6 bg-blue-50 rounded-xl p-4 sm:p-6">
            <h5 className="font-bold text-gray-900 mb-2 sm:mb-3 flex items-center text-sm sm:text-base">
              <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center mr-2 text-blue-600">
                <i className="ri-map-line"></i>
              </div>
              交通資訊
            </h5>
            <div className="space-y-2 sm:space-y-3 text-xs sm:text-sm text-gray-700">
              <div className="flex items-start">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mr-2 flex-shrink-0">
                  <i className="ri-bus-line text-blue-600"></i>
                </div>
                <div>
                  <strong>公車：</strong>搭乘14、15、21、31路公車至北屯路站下車，步行約3分鐘
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mr-2 flex-shrink-0">
                  <i className="ri-car-line text-blue-600"></i>
                </div>
                <div>
                  <strong>開車：</strong>國道1號台中交流道下，往台中市區方向，沿北屯路直行即可抵達
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mr-2 flex-shrink-0">
                  <i className="ri-parking-box-line text-blue-600"></i>
                </div>
                <div>
                  <strong>停車：</strong>附近設有公有停車場，步行約5分鐘
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
